import { useContext } from 'react'
import { Link } from 'react-router-dom'
import IMKLogo from '../../../assets/IMK_Logo.jpg'
import ManitobaLogo from '../../../assets/MBSA_Logo.jpg'
import ParentFormDataContext from '../../../contexts/ParentFormDataContext'
import RoutesFormDataContext from '../../../contexts/RoutesFormDataContext'
export interface ILogo {
    className?: string
    width: number
    height: number
}

const Logo: React.FC<ILogo> = ({ className, width, height }) => {

    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )
    const { routesFormData, setRoutesFormData } = useContext(
        RoutesFormDataContext
    )
    const urlParameters = new URLSearchParams(window.location.search)

    const location = (urlParameters.get('prov') ? urlParameters.get('prov') : 'ON')
    const language = Number(urlParameters.get('lang') ? urlParameters.get('lang') : "0")
    const orgGuid = urlParameters.get('og') ? urlParameters.get('og')?.toString() : ''
    let logo = IMKLogo

    if (parentFormData?.Province?.id === 'MB' || location === 'MB') {
        logo = ManitobaLogo
    }

    const returnHome = () => {
        let returnURL = parentFormData.ReturnHome;
        if (parentFormData.Language === 1) {
            if (parentFormData.ReturnHome.includes("insuremykids") || parentFormData.ReturnHome.includes("manitobastudentinsurance")) {
                returnURL = parentFormData.ReturnHome + '/fr'
            }
            else {
                returnURL = parentFormData.ReturnHome + "?lang=1"
            }
        }
        return returnURL
    }

    return (
        <div className="flex justify-center items-center pb-2 pt-1">
            <Link to={returnHome()}>
                <img src={logo} width={width} height={height} alt="IMKLogo" />
            </Link>
        </div>
    )
}

export default Logo
